import { Full, View } from '../../constants/permissions';

export const hasViewAccess = (permissions: string[]): boolean => {
  return permissions?.some((p) => p === Full || p === View) === true;
};

export const hasFullAccess = (permissions: string[]): boolean => {
  return permissions?.some((p) => p === Full) === true;
};
